import { useState } from 'react'
import { needPaths } from '../content/site'
import { ArrowLink } from './ArrowLink'

export function NeedsNavigator() {
  const [activeId, setActiveId] = useState(needPaths[0].id)
  const active = needPaths.find((path) => path.id === activeId) ?? needPaths[0]
  const ActiveIcon = active.icon

  return (
    <section className="needs-navigator section-light" aria-labelledby="needs-title">
      <div className="needs-navigator__header" data-reveal>
        <h2 id="needs-title">What needs attention?</h2>
        <p>Start with the outcome. We can work out the right technology from there.</p>
      </div>
      <div className="needs-tabs" role="tablist" aria-label="Common business technology needs">
        {needPaths.map((path, index) => (
          <button
            type="button"
            role="tab"
            aria-selected={activeId === path.id}
            aria-controls={`need-panel-${path.id}`}
            id={`need-tab-${path.id}`}
            key={path.id}
            onClick={() => setActiveId(path.id)}
          >
            <span>{String(index + 1).padStart(2, '0')}</span>
            {path.label}
          </button>
        ))}
      </div>
      <div
        className="needs-panel"
        role="tabpanel"
        id={`need-panel-${active.id}`}
        aria-labelledby={`need-tab-${active.id}`}
        key={active.id}
      >
        <ActiveIcon aria-hidden="true" strokeWidth={1.15} />
        <div>
          <h3>{active.title}</h3>
          <p>{active.body}</p>
          <ArrowLink href={active.href}>Explore how we help</ArrowLink>
        </div>
        <div className="needs-panel__drawing" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </section>
  )
}
